<template>
    <el-form class="login-container" id="loginForm" :model="loginFormModel" :rules="rules" ref="loginForm"
             label-width="0px">
      <h3 class="title">系统登录</h3>
      <el-form-item prop="user_no">
        <el-input v-model="loginFormModel.user_no"
                  autocomplete="on" placeholder="请输入用户名"
                  @keydown.enter.native="onKeydown('inputPwd')">
          <i slot="prepend" class="iconfont icon-user"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input id="inputPwd"
                  type="password"
                  v-model="loginFormModel.password"
                  autocomplete="off" placeholder="请输入密码"
                  @keydown.enter.native="onKeydown('code')">
          <i slot="prepend" class="iconfont icon-password"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input id="code"
          v-model="loginFormModel.code"
          auto-complete="off"
          placeholder="验证码"
          style="width: 63%"
          @keyup.enter.native="login('loginForm')">
          <i slot="prepend" class="iconfont icon-login_captcha"></i>
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" class="login-code-img"/>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="isLoading" style="width:100%; " @click="login('loginForm')">登 录</el-button>
        <!--@click="submitForm('loginFormModel')"-->
      </el-form-item>
      <el-dialog id="dlgPwdUpdate" title="修改密码" :closeOnClickModal="false" :visible.sync="dlgPwdUpdateVisible" @close="onPwdUpdateClose">
        <pwd-update ref="pwdUpdate" v-on:onPwdSaved="afterPwdSaved"></pwd-update>
        <span slot="footer" class="dialog-footer" style="line-height: 40px; text-align: center; padding: 2px;">
        <el-button type="primary" size="mini" plain icon="el-icon-circle-check" @click="savePwd">提 交</el-button>
        <el-button type="primary" size="mini" plain icon="el-icon-circle-close"
                   @click="onPwdUpdateClose">关 闭</el-button>
      </span>
      </el-dialog>
    </el-form>

</template>

<script>
  import {mapGetters} from 'vuex';
  import md5 from 'js-md5';
  import {resetLocalCache} from '../commons'
  import CryptoUtil from '../libs/CryptoUtil';
  import PwdUpdate from '@/components/PwdUpdate.vue';

  export default {
    data() {
      return {
        dlgPwdUpdateVisible: false,
        userInfo: null,
        loginFormModel: {
          user_no: '',
          password: '',
          captchaId: "",//验证码id
          code: "",//验证码
          secretKey: null, //密钥
          invoker: 201,  // 固定值（康华接口规定）
        },
        loginFormMargin: {
          top: 0,
          left: 0
        },
        rules: {
          user_no: [
            {required: true, message: '用户名不能为空', trigger: 'blur'},
            //{min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '密码不能为空', trigger: 'blur'},
          ],
          code: [
            {required: true, message: '请填写验证码', trigger: 'blur'},
          ]
        },
        // 验证码开关
        captchaOnOff: true,
        // 验证码地址
        codeUrl: "",
      }
    },
    props: {},
    computed: {
      ...mapGetters(['isLoading']),
    },
    components: {
      PwdUpdate
    },
    methods: {
      getCode() {
        this.apiSystem.getCaptcha((data)=>{
          this.codeUrl = "data:image/gif;base64," + data.imageBase64;
          this.loginFormModel.captchaId = data.captchaId;
          this.loginFormModel.secretKey = data.secretKey;
        }, (error)=>{
          this.$alert(error.message, '异常', {type: 'error'});
          this.$store.dispatch('loaded');
        });
      },
      onKeydown(toFocusId) {
        $(`#${toFocusId}`).focus().select();
      },
      login(formName) {
        const _this = this;
        _this.$refs[formName].validate((valid) => {
          if (!valid) {
            return false;
          }
          let loginParam = Object.assign({}, _this.loginFormModel);
          //密钥不需要提交
          delete loginParam.secretKey;
          loginParam.password = md5(_this.loginFormModel.password);//密码md5
          loginParam.password = CryptoUtil.aesEncrypt(loginParam.password, _this.loginFormModel.secretKey);//再次对称加密

          _this.$store.dispatch('loading');
          _this.apiSystem.login(loginParam,
            (userData) => {
              _this.$store.dispatch('loaded');
              userData.functions = null;
              _this.userInfo = userData;
              //先保存登录信息，因为当强制修改密码时需要调用接口（需要验证令牌）： /secretKey
              _this.$store.dispatch('setUserInfo', userData);

              if(userData.is_first_signin == 0){
                //强制修改密码
                _this.dlgPwdUpdateVisible = true;
                setTimeout(()=>{
                  _this.$refs.pwdUpdate.onShow(_this.loginFormModel.password);
                },300);
              }else{
                _this.toLadUserSetting();
              }
            },
            (error) => {
              _this.$alert(error.message, '异常', {type: 'error'});
              _this.$store.dispatch('loaded');
            });
        });
      },
      //登陆成功后，加载默认配置
      toLadUserSetting(){
        //获取用户的系统参数配置
        this.loadUserSetting();
      },
      //强制修改密码
      savePwd() {
        this.$refs.pwdUpdate.saveData();
      },
      onPwdUpdateClose() {
        this.userInfo = null;
        this.$store.dispatch('setUserInfo', this.userInfo);
        this.dlgPwdUpdateVisible = false;
      },
      afterPwdSaved() {
        //强制修改密码成功后
        this.dlgPwdUpdateVisible = false;
        this.userInfo.is_first_signin = 1;
        this.$store.dispatch('setUserInfo', this.userInfo);
        this.toLadUserSetting();
      },
      loadUserSetting() {
        const _this = this;
        _this.$store.dispatch('loading');
        _this.apiSystem.getUserSetting(_this.$store.state.userInfo.org_id, _this.$store.state.userInfo.id,
          (dataList) => {
            _this.$store.dispatch('setUserSetting', dataList);
            _this.$store.dispatch('loaded');

            _this.$emit('loginSuccess');
            _this.$router.push('/');
          },
          (error) => {
            _this.$alert("加载用户参数配置发生异常：" + error.message, '异常', {type: 'error'});
            _this.$store.dispatch('loaded');
          });

      },
    },
    watch: {},
    mounted() {
      resetLocalCache();
    },
    created() {
      this.getCode();
    },
  }
</script>

<style scoped lang="scss">
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    /*margin: 180px auto;*/
    width: 300px;
    padding: 30px 30px 15px 30px;
    /*background: #fff;*/
    /*border: 1px solid #eaeaea;*/
    /*box-shadow: 0 0 25px #cac6c6;*/
  }

  .login-container {
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
  }
  .login-code {
    width: 34%;
    height: 38px;
    float: right;
    img {
      cursor: pointer;
      vertical-align: middle;
    }
  }
  .login-code-img {
    height: 38px;
  }
  .login-agreement {
    float: right;
  }
</style>





// WEBPACK FOOTER //
// src/components/Login.vue